import { Pipe, PipeTransform } from '@angular/core';

import { IsTherePreWiringDevicesPipe } from './is-there-pre-wiring-devices.pipe';
import { FilterOutSelectedItemsPipe } from './filter-out-selected-items.pipe';
import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'preWiringDevicesIncluded',
    standalone: false
})
export class PreWiringDevicesIncludedPipe implements PipeTransform {

  transform(bomModels: IBomModel[],
            bomModelsAccessories: IBomModel[],
            selectedItems: number[],
            selectedItemsAccessories: number[]): boolean {
    const filterSelectedItems = new FilterOutSelectedItemsPipe().transform(bomModels, selectedItems, 'id');
    const filterSelectedAccessories = new FilterOutSelectedItemsPipe().transform(bomModelsAccessories, selectedItemsAccessories, 'id');

    return new IsTherePreWiringDevicesPipe().transform(filterSelectedItems) ||
      new IsTherePreWiringDevicesPipe().transform(filterSelectedAccessories);
  }

}
